import { createApp } from "vue"
import { createPinia } from "pinia"
import Router from "@/router"
import { initSentry } from "./global"
import Vant from "vant"
import App from "./App.vue"
import "./App.ts"

const app = createApp(App)
app.use(createPinia()).use(Router).use(Vant).mount("#emp-root")

app.config.errorHandler = (error, instance, info) => {
	console.log(`[App Error] info:`, info)
	console.log(`[App Error] error:`, error)
	console.log(`[App Error] instance:`, instance)
}

initSentry(app, Router)

